export default __webpack_public_path__ + "static/media/casal_3.525ce430.jpg";